import BlogLegacyContent from "./BlogLegacyContent";

export { BlogLegacyContent };
